__turbopack_context__.v({
  "backdrop": "RedesSocialesModal-module__jaXfZG__backdrop",
  "cardActions": "RedesSocialesModal-module__jaXfZG__cardActions",
  "cardInfo": "RedesSocialesModal-module__jaXfZG__cardInfo",
  "cardLeft": "RedesSocialesModal-module__jaXfZG__cardLeft",
  "closeBtn": "RedesSocialesModal-module__jaXfZG__closeBtn",
  "copyBtn": "RedesSocialesModal-module__jaXfZG__copyBtn",
  "fadeIn": "RedesSocialesModal-module__jaXfZG__fadeIn",
  "header": "RedesSocialesModal-module__jaXfZG__header",
  "headerLeft": "RedesSocialesModal-module__jaXfZG__headerLeft",
  "iconBadge": "RedesSocialesModal-module__jaXfZG__iconBadge",
  "modalCard": "RedesSocialesModal-module__jaXfZG__modalCard",
  "networkDesc": "RedesSocialesModal-module__jaXfZG__networkDesc",
  "networkHandle": "RedesSocialesModal-module__jaXfZG__networkHandle",
  "networkIcon": "RedesSocialesModal-module__jaXfZG__networkIcon",
  "networkName": "RedesSocialesModal-module__jaXfZG__networkName",
  "socialCard": "RedesSocialesModal-module__jaXfZG__socialCard",
  "socialList": "RedesSocialesModal-module__jaXfZG__socialList",
  "subtitle": "RedesSocialesModal-module__jaXfZG__subtitle",
  "tabBtn": "RedesSocialesModal-module__jaXfZG__tabBtn",
  "tabBtnActive": "RedesSocialesModal-module__jaXfZG__tabBtnActive",
  "tabsBar": "RedesSocialesModal-module__jaXfZG__tabsBar",
  "title": "RedesSocialesModal-module__jaXfZG__title",
  "visitBtn": "RedesSocialesModal-module__jaXfZG__visitBtn",
  "zoomIn": "RedesSocialesModal-module__jaXfZG__zoomIn",
});
